import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FaRedditAlien, FaTelegramPlane } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { SiX } from "react-icons/si";
import { SiBluesky } from "react-icons/si"; 

const socialLinks = [
  {
    href: "https://www.tiktok.com/@mycashcanvas?_r=1&_t=ZN-92GHij65Rhe",
    icon: <FaTiktok className="text-2xl" />,
    label: "TikTok",
  },
  {
    href: "https://x.com/mycashcanvas",
    icon: <SiX className="text-2xl" />,
    label: "X",
  },
  {
    href: "https://www.reddit.com/r/CashCanvas/s/lo3kKDkEtB",
    icon: <FaRedditAlien className="text-2xl" />,
    label: "Reddit",
  },
  {
    href: "https://t.me/mycashcanvas",
    icon: <FaTelegramPlane className="text-2xl" />,
    label: "Telegram",
  },
  {
    href: "https://bsky.app/profile/cashcanvas.bsky.social",
    icon: <SiBluesky className="text-2xl" />,
    label: "Bluesky",
  },
  {
    href: "https://www.facebook.com/share/16bKjEwtzp/",
    icon: <FaFacebookF className="text-2xl" />,
    label: "Facebook",
  },
  {
    href: "https://www.linkedin.com/company/cashcanvas",
    icon: <FaLinkedinIn className="text-2xl" />,
    label: "LinkedIn",
  },
  {
    href: "https://www.instagram.com/mycashcanvas?igsh=Nm9rdW8xcnpxbDU5",
    icon: <FaInstagram className="text-2xl" />,
    label: "Instagram",
  },
];

const Footer = () => {
  return (
    <footer className="w-full bg-btn-primary border-t border-gray-200 py-6 px-4 md:px-12">
      {/* Top row: social icons + legal links */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 space-y-6 md:space-y-0">
        {/* Social Icons */}
        <div className="flex space-x-6">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-btn-secondary transition-colors"
              aria-label={social.label}
            >
              {social.icon}
            </a>
          ))}
        </div>

        {/* Legal Links */}
        <div className="flex flex-wrap justify-center md:justify-end items-center font-sans space-x-6 text-sm text-white">
          <Link to="/terms" className="hover:text-btn-secondary transition-colors">
            Terms
          </Link>
          <Link to="/privacy-policy" className="hover:text-btn-secondary transition-colors">
            Policy
          </Link>
        </div>
      </div>

      {/* Bottom row: copyright */}
      <div className="text-center text-sm text-white font-sans">
        &copy; {new Date().getFullYear()} Cash Canvas
      </div>
    </footer>
  );
};

export default Footer;